import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=d9aaa5bc&scoped=true&"
import script from "./weChat.vue?vue&type=script&lang=js&"
export * from "./weChat.vue?vue&type=script&lang=js&"
import style0 from "./weChat.vue?vue&type=style&index=0&id=d9aaa5bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9aaa5bc",
  null
  
)

export default component.exports